import { FormControl } from '@angular/forms';

export function unacceptedValuesValidator(unacceptedValues: any[]) {
    return (control: FormControl): { [key: string]: any } => {
        if (unacceptedValues.indexOf(control.value) >= 0) {
            return { unacceptedValue: true };
        }
    };
}
